<template>
  <van-popup v-model="showpPopup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
    <div class="content-container">
      <div class="tip-box" v-if="signCount + remainCount >= 5 && signCount < 5">
        <span
          >本周已累计签到<span class="num">{{ signCount }}</span
          >天</span
        >
        <span>明天继续加油哦！</span>
      </div>

      <div class="tip-box" v-else-if="signCount == 5">
        <span
          >本周已累计签到<span class="num">{{ signCount }}</span
          >天</span
        >
        <span>赶紧提现奖励吧！</span>
      </div>

      <div class="tip-box" v-else-if="signCount > 5">
        <span
          >本周已累计签到<span class="num">{{ signCount }}</span
          >天</span
        >
        <span>已成功获得现金奖励!</span>
      </div>

      <div class="tip-box" v-else-if="signCount + remainCount < 5">
        <span>本周签到未满5天</span>
        <span>下周早点哦！</span>
      </div>

      <img class="close" @click="showpPopup = false" src="@/static/images/activityCenter/202405/01/close.png" />
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      showpPopup: false,
      signCount: null, //本周签到天数
      remainCount: null //本周未签到天数
    };
  },

  methods: {
    open(signCount, remainCount) {
      this.showpPopup = true;
      this.signCount = signCount;
      this.remainCount = remainCount;
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
  padding-bottom: 550px;
}
.content-container {
  position: relative;
  width: 560px;
  height: 611px;
  background: url('~@/static/images/activityCenter/202405/01/09.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .tip-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 320px;
    width: 400px;
    text-align: center;
    span {
      color: #772d00;
      font-size: 32px;
      font-weight: bold;
      letter-spacing: 0.2px;
      display: flex;
      justify-content: center;
      align-items: center;
      .num {
        color: #fc2e15;
        font-size: 52px;
        margin-left: 3px;
        margin-right: 3px;
      }
    }
  }
  .close {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: -230px;
    left: 50%;
    margin-left: -30px;
  }
}
</style>
